import "date-fns";
import React, { useCallback, useEffect, useState } from "react";
import DateFnsUtils from "@date-io/date-fns";
import {
	MuiPickersUtilsProvider,
	KeyboardDateTimePicker,
} from "@material-ui/pickers";
import Shared from "../../common/shared";
import { useGetComponentStringsContext } from "../../hooks/useGetComponentStrings";

export interface DateTimePickerProps {
	dateTime: Date | string;
	minDateTime?: Date;
	onDateTimeValueChange: (date: Date | string) => void;
	isReadOnly: boolean;
	requiresValidation: boolean;
}

const DateTimePicker = (props: DateTimePickerProps) => {
	const strings = useGetComponentStringsContext().DateTimePicker;
	const [isError, setIsError] = useState(false);

	const isDateTimeValid = useCallback(
		(dateTime: Date | string) => {
			return props.minDateTime !== null &&
				Shared.isBeforeCurrentDateTime(dateTime, props.minDateTime!)
				? true
				: false;
		},
		[props.minDateTime]
	);

	useEffect(() => {
		if (props.requiresValidation) {
			setIsError(isDateTimeValid(props.dateTime));
		}
	}, [isDateTimeValid, props.dateTime, props.requiresValidation]);

	const handleChange = (value: Date | string) => {
		setIsError(isDateTimeValid(value));
		props.onDateTimeValueChange(value);
	};

	return (
		<div>
			<MuiPickersUtilsProvider utils={DateFnsUtils}>
				<KeyboardDateTimePicker
					data-testid="dateTimeInput"
					variant="inline"
					ampm={false}
					label={strings.selectDateTimeLabel}
					value={props.dateTime}
					onChange={(event: any) =>
						props.isReadOnly ? {} : handleChange(event)
					}
					disablePast
					format="dd/MM/yyyy HH:mm"
					error={(!props.dateTime && props.requiresValidation) || isError}
					helperText={
						!props.dateTime && props.requiresValidation
							? strings.dateTimeRequiredErrorMessage
							: isError
							? strings.invalidDateTimeErrorMessage
							: ""
					}
					fullWidth
					InputProps={{ readOnly: props.isReadOnly }}
					disabled={props.isReadOnly}
					KeyboardButtonProps={{
						...({ "data-testid": "changeDate" } as any),
					}}
				/>
			</MuiPickersUtilsProvider>
		</div>
	);
};

export default DateTimePicker;
